export default {
  dbi_global_view_top_genre_per_market: '单市场品类表现',
  dbi_global_view_top_market_per_genre: '单品类市场表现',
  dbi_global_view_total_market: '整体市场',
  dbi_global_view_console_games: '主机',
  dbi_global_view_region: '地区',
  dbi_global_view_markets: '市场',
  dbi_global_view_core_markets: '核心市场',
  dbi_global_view_year: '年',
  dbi_global_view_genre: '品类',
  dbi_global_view_main_sub_genre: '主+副品类',
  dbi_global_view_downloads: '下载量',
  dbi_global_view_top_5_genres_by_revenue: '收入排名Top5的品类',
  dbi_global_view_top_5_genres_by_downloads: '下载量排名Top5的品类',
  dbi_global_view_top_5_regions_by_revenue: '收入排名Top5的地区',
  dbi_global_view_top_5_regions_by_downloads: '下载量排名Top5的地区',
  dbi_global_view_top_5_markets_by_revenue: '收入排名Top5的市场',
  dbi_global_view_top_5_markets_by_downloads: '下载量排名Top5的市场',
  dbi_global_view_genre_classification_data_source_tips: '品类分类及数据来自{source}，2024年起不再更新',
  dbi_global_view_genre_classification_data_source_tips_mobile: '品类分类来自IEGG，数据来自data.ai。',
  dbi_global_view_search_any_region: '在表格内搜索任一地区',
  dbi_global_view_search_any_market: '在表格内搜索任一市场',
  dbi_global_view_search_any_genre: '在表格内搜索任一品类',
  dbi_global_view_market_settings: '市场设置',
  dbi_global_view_1st_genre_revenue: '排名第一的品类及其收入',
  dbi_global_view_2nd_genre_revenue: '排名第二的品类及其收入',
  dbi_global_view_3rd_genre_revenue: '排名第三的品类及其收入',
  dbi_global_view_1st_genre_downloads: '排名第一的品类及其下载量',
  dbi_global_view_2nd_genre_downloads: '排名第二的品类及其下载量',
  dbi_global_view_3rd_genre_downloads: '排名第三的品类及其下载量',
  dbi_global_view_1st_region_revenue: '排名第一的地区及其收入',
  dbi_global_view_2nd_region_revenue: '排名第二的地区及其收入',
  dbi_global_view_3rd_region_revenue: '排名第三的地区及其收入',
  dbi_global_view_1st_region_downloads: '排名第一的地区及其下载量',
  dbi_global_view_2nd_region_downloads: '排名第二的地区及其下载量',
  dbi_global_view_3rd_region_downloads: '排名第三的地区及其下载量',
  dbi_global_view_1st_markets_revenue: '排名第一的市场及其收入',
  dbi_global_view_2nd_markets_revenue: '排名第二的市场及其收入',
  dbi_global_view_3rd_markets_revenue: '排名第三的市场及其收入',
  dbi_global_view_1st_markets_downloads: '排名第一的市场及其下载量',
  dbi_global_view_2nd_markets_downloads: '排名第二的市场及其下载量',
  dbi_global_view_3rd_markets_downloads: '排名第三的市场及其下载量',
  dbi_global_view_by_revenue: '按收入分布',
  dbi_global_view_by_Players: '按玩家分布',
  dbi_global_view_market_header: '市场规模',
  dbi_global_view_golbal_market: '全球游戏市场概况',
  dbi_global_view_year_revenue: '收入（美元）',
  dbi_global_view_trends_market_platform: '各平台市场规模趋势',
  dbi_global_view_trends_revenue_region: '主要地区市场规模趋势',
  dbi_global_view_region_genre: '按品类划分的地区表现',
  dbi_global_view_year_map: '年收入与增长图',
  dbi_global_view_year_details: '年收入与增长详情',
  dbi_global_view_game_count: '游戏数量',
  dbi_global_view_revenue_growth: '收入增长',
  dbi_global_view_revenue_global: '全球人均收入',
  dbi_global_view_play_online_population: '在线人数',
  dbi_global_view_play_trends: '玩家总数趋势',
  dbi_global_view_play_trends_payers: '付费总数趋势',
  dbi_global_view_play_region: '按主要地区划分的游戏付费用户',
  dbi_global_view_play_Abbreviation_year: '逐年的缩写，数据是和上一年的数据比较.',
  dbi_global_view_play_map: '年玩家和付费玩家地图',
  dbi_global_view_play_details: '年玩家和年度付费玩家市场详情',
  dbi_global_view_play_payers: '玩家多,付费玩家多的国家',
  dbi_global_view_play_annual: '平均付费玩家年度付费值（美元）',
  dbi_global_view_play_little_payers: '玩家多,付费玩家少的国家',
  dbi_global_view_growth: '增长',
  dbi_global_view_players: '玩家',
  dbi_global_view_payers: '付费',
  dbi_global_view_payers2: '付费玩家',
  dbi_global_view_revenue_tip_text: ' 当前提供头部约100个国家的收入数据，我们选择收入和年增长率的中位数为标准进行划分。收入大于等于100个国家中位数，年增长率大于等于中位数的国家为明星市场；收入大于等于中位数，年增长率小于中位数的国家为成熟市场；收入小于中位数，年增长率大于等于中位数的国家为问号市场；收入小于中位数，年增长率小于中位数的为瘦狗市场。',
  dbi_global_view_player_tip_text: '当前提供头部约100个国家或市场的玩家和付费玩家数据。我们选择玩家数和付费玩家数量的中位数为标准进行划分。玩家数量大于等于100个市场中位数，付费玩家数量大于等于中位数的市场为“玩家多，付费玩家多”市场，玩家数量大于等于100个市场中位数，付费玩家数量小于中位数的市场为“玩家多，付费玩家少”市场，并且展示平均付费玩家年游戏付费值。',
};
